import { useHomeQuery } from '@/queries/home.query';
import { FadeIn, FadeInStagger } from './animation/FadeIn';
import { ContainerFluid } from './container/Container';
import { Body, H3 } from './ui/typography/Typography';

/* ========================
 * Skeleton Stats
 * ======================== */
const StatsSkeleton = () => (
  <ContainerFluid
    className={`
        bg-gradient-to-r from-gray-500 via-gray-600 to-gray-500 animate-pulse
      `}
  >
    <dl className="grid py-6 sm:py-10 w-full max-w-screen-2xl gap-x-8 gap-y-8 text-white grid-cols-2 mx-auto md:grid-cols-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div
          key={i}
          className="flex flex-col gap-y-8 lg:gap-y-6 border-l-2 border-gray-500/40 pl-6 animate-pulse"
        >
          <div className="h-4 w-16 lg:h-8 lg:w-24 rounded bg-gray-300/70" />
          <div className="h-2 w-20 lg:h-4 lg:w-32 rounded bg-gray-300/50" />
        </div>
      ))}
    </dl>
  </ContainerFluid>
);

export default function StatsSection() {
  /* ========================
   * Home Query (shared cache)
   * ======================== */
  const { data, isLoading, isError } = useHomeQuery();

  /* ========================
   * Mapping Statistics
   * ======================== */
  const stats =
    data?.data?.statistics
      ?.slice()
      .sort((a, b) => a.position - b.position)
      .map((item) => ({
        id: item.id ?? item.position,
        value: item.label,
        name: item.description,
      })) ?? [];

  if (isLoading) return <StatsSkeleton />;
  if (isError || !stats.length) return null;
  return (
    <ContainerFluid
      className={`
        relative py-6 sm:px-6 sm:py-6 -mt-2 transition-colors duration-500
        ${isLoading ? 'bg-gray-500 animate-pulse' : 'backcustomstats bg-primary'}
      `}
    >
      <FadeInStagger faster>
        <dl className="grid w-full max-w-screen-2xl gap-x-8 gap-y-8 text-white grid-cols-2 mx-auto sm:gap-y-16 md:max-w-none md:grid-cols-4 md:my-4">
          {stats.map((stat, index) => (
            <FadeIn delay={index * 0.15} key={stat.id}>
              <div className="flex flex-col gap-y-2 sm:gap-y-3 border-l-2 border-white/10 pl-6">
                <H3 className="text-white font-semibold tracking-tight">{stat.value}</H3>
                <Body className="text-white font-medium">{stat.name}</Body>
              </div>
            </FadeIn>
          ))}
        </dl>
      </FadeInStagger>
    </ContainerFluid>
  );
}
